export default __webpack_public_path__ + "a3b427502e64111ee6bd07d739278ab9.png";